export const consultingQueryKey = {
	selectedChild: '/ug/consulting/selected-child',
	myReservations: '/ug/consulting/reservations',
}

export const diagnosisQueryKey = {
	sheetList: '/diagnostic/user-diagnostic-list',
}

export const API_USER = 'API_USER'
